import React, { useState, useRef, useEffect } from "react"
import { TabView, TabPanel } from "primereact/tabview"
import { CardBody, Col, Container, Row, DropdownItem, DropdownMenu, } from "reactstrap"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import "primereact/resources/themes/saga-blue/theme.css"
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css"
import { Dialog } from "primereact/dialog"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import { Dropdown } from "primereact/dropdown"
import { InputTextarea } from "primereact/inputtextarea"
import Modal from "react-bootstrap/Modal";
import { Controller, useForm } from "react-hook-form"
import { emailValidation, MaxLengthValidation, MinLengthValidation, onlyAlphabetsandSpaces, onlyNumbers, passwordPattern } from "utils/Constants"
import axios from "axios"
import moment from "moment"
import { triggerAlert, ConfirmationAlert } from "utils/CommonFunctions"
import Lookup from "./Lookup"
import Settingadm from "./Settingadm"

const AdminDashboard = () => {

  const [isLoading, setIsLoading] = useState(false)
  const [street1, setStreet1] = useState('');
  const [street2, setStreet2] = useState('')
  const [selectedCity, setSelectedCity] = useState(null);
  const [addCountries, setAddCountries] = useState([]);
  const [addStates, setAddStates] = useState([]);
  const [addCities, setaddCities] = useState([]);
  const [selectedState, setSelectedState] = useState(null)
  const [postalCode, setPostalCode] = useState('');
  const [userRoles, setUserRoles] = useState([])
  const [selectedLabel1, setSelectedLabel1] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [groupitem, setgroupitem] = useState([])
  const [selectedGroupKey, setSelectedGroupKey] = useState(null);
  const [categoriesitem, setcategoriesitem] = useState([])
  const { register, handleSubmit, watch, formState: { errors }, trigger, control, setValue, reset } = useForm();
  const [selectedCategoryKey, setSelectedCategoryKey] = useState(null);
  const [isDialogVisible, setDialogVisible] = useState(false) // Controls Dialog visibility
  const [selectedUser, setSelectedUser] = useState(null) // Holds selected user for editing
  const [visible, setVisible] = useState(false)
  const [address, setAddress] = useState("")
  const [userList, setUserList] = useState([])
  const [formVisible, setFormVisible] = useState(false) // Controls the form visibility
  const [isEditMode, setIsEditMode] = useState(null) // True when editing, false when adding


  // Reset form after submit or cancel
  const resetForm = () => {
    reset()
    setFormVisible(false) // Hide the form
    setIsEditMode(null)
  }

  // Options for role and status dropdowns


  const [isFormVisible, setIsFormVisible] = useState(false)
  const [isEditModeActive, setIsEditModeActive] = useState(false)
  const [userData, setUserData] = useState({
    roleNameField: "",
    creationDateField: "",
    actionField: "",
  })
  // Reset form data and hide form
  const resetFormFields = () => {
    setUserData({
      roleNameField: "",
      creationDateField: "",
      actionField: "",
    })
    setIsFormVisible(false)
    setaddrolespopup(false)
    setIsEditModeActive(false)
  }




  /////////////////////////////////////////////// Sahitis Code /////////////////////////////////////////////////////////////// 

  const labels = [
    { name: 'Work ', code: 'WORK' },
    { name: 'Home', code: 'HOME' },
    { name: 'Other', code: 'Other' },

  ];

  const getaddCountries = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-countries/`, {});
      const transformedData = response.data.results.map((Countries) => ({
        name: Countries.name,
        id: Countries.country_id,
      }));
      setAddCountries(transformedData);
      // //console.log(transformedData)

    }
    catch (error) {
    }
  };
  const getaddStates = async (countryId) => {
    try {
      const response = await axios.get(`/api/v1/get-all-states/?country_id=${countryId}`, {});
      const transformedData = response.data.results.map((city) => ({
        name: city.name,
        id: city.state_id,
      }));
      setAddStates(transformedData);

    }
    catch (error) {
    }
  };
  const getaddCities = async (stateId) => {
    try {
      const response = await axios.get(`/api/v1/get-all-cities/?state_id=${stateId}`, {});
      const transformedData = response.data.results.map((city) => ({
        name: city.name,
        id: city.city_id,
      }));
      setAddCities(transformedData);

    }
    catch (error) {
    }
  };

  const [rolesval, setrolesval] = useState()

  const fetchUserRoles = async () => {
    try {
      const response = await axios.get(`api/v1/get-all-roles/`)
      const transformedDataroles = response.data.results.map((city) => ({
        name: city.role_name,
        id: city.role_id,
      }));
      setUserRoles(transformedDataroles);

    }
    catch (error) {
      //console.log('error occured ', error.message)
    }
  }
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [department, setdepartment] = useState(null);
  const [companies, setcompanies] = useState([])
  const [departmentslist, setdepartmentslist] = useState([])

  const fetchAllCompanies = async () => {
    try {
      const response = await axios.get(`api/v1/get-all-companies/`)
      const transformedDataroles = response.data.results.map((city) => ({
        name: city.company_name,
        id: city.company_id,
      }));
      setcompanies(transformedDataroles);

    }
    catch (error) {
      //console.log('error occured ', error.message)
    }
  }
  const fetchAllDepartments = async () => {
    try {
      const response = await axios.get(`api/v1/get-all-departments/`)
      const transformedDataroles = response.data.results.map((city) => ({
        name: city.name,
        id: city.department_id,
      }));
      setdepartmentslist(transformedDataroles);
    }
    catch (error) {
      //console.log('error occured ', error.message)
    }
  }

  // Handle edit
  const handleEditUser = (rowData) => {

    console.log(rowData)
    setValue('user_id', rowData.user_id);
    setValue('email', rowData.email);
    setValue('password', rowData.password);
    setValue("role_id", rowData.role_id, { shouldValidate: true }); // Ensure validation runs
    // setValue('company', rowData.company);
    setValue('first_name', rowData.first_name);
    setValue('middle_name', rowData.middle_name);
    setValue('last_name', rowData.last_name);
    setValue('phone_number', rowData.phone_number);
    setValue('job_title', rowData.job_title);
    // setValue('department', rowData.department);
    // setValue('category', rowData.category);
    // setValue('group', rowData.group);
    setStreet1(rowData.street_address);
    setStreet2(rowData.street_address_line_2);
    setSelectedLabel1(rowData.label);
    setPostalCode(rowData.pincode);
    setSelectedCompany(rowData.company)
    setdepartment(rowData.department)
    setSelectedGroupKey(rowData.group)
    setSelectedCategoryKey(rowData.category)
    setrolesval(rowData.role)
    setValue('label', rowData.label);
    setIsEditMode(rowData?.id)
    // 

  }


  const addNewUser = async (data) => {
    setIsLoading(true);
    try {
      const response = await axios.post(`/api/v1/users/`, data);
      //console.log("response", response)
      if (response.status === 201 || response.status === 200) {
        setIsLoading(false);
        fetchUserManagementDetails();
        setFormVisible(false)
        resetForm();
      }
    } catch (error) {
      //console.error(error);
      setIsLoading(false);
    }
  }
  const editNewUser = async (id, data) => {
    setIsLoading(true);
    try {
      const response = await axios.put(`/api/v1/users/${id}/`, data);
      //console.log("response", response)
      if (response.status === 201 || response.status === 200) {
        setFormVisible(false)
        fetchUserManagementDetails();
        resetForm();
        setIsLoading(false);
      }
    } catch (error) {
      //console.error(error);
      setIsLoading(false);
    }
  }
  // Handle form submit (Add or Edit user)
  const handleFormSubmit = (data) => {
    //console.log("data", data);
    data.street_address = street1;
    data.street_address_line_2 = street2;
    data.pincode = postalCode;
    data.label = selectedLabel1?.name;
    data.category = selectedCategoryKey
    data.group = selectedGroupKey;
    data.department = department
    data.role = rolesval
    if (isEditMode) {
      // Update existing user
      editNewUser(isEditMode, data);
    } else {
      // Add new user
      addNewUser(data)
    }
    // resetForm()
  }

  // Handle delete
  const handleDeleteUser = id => {
    ConfirmationAlert('You want to continue?', 'Continue', async () => {
      try {
        const response = await axios.delete(`/api/v1/users/${id}/`, {});
        if (response.status === 200) {
          const responseData = response.data.results;
          fetchUserManagementDetails();
        }

      } catch (error) {

      }
    })
  }

  const getcategoriesitem = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-categories/`, {});
      if (response.data && response.data.results) {
        const transformedData = response.data.results.map((Categories) => ({
          name: Categories.name,
          id: Categories.category_id,
        }));
        setcategoriesitem(transformedData);
      }
    } catch (error) {
    }
  };

  const getgroupsitemsub = async (category_ids) => {
    try {
      const response = await axios.get(`/api/v1/get-all-groups/?category_id=${category_ids}`, {
      });
      if (response.data && response.data.results) {
        const transformedDatagroup = response.data.results.map((Groups) => ({
          name: Groups.name,
          id: Groups.group_id,
        }));
        setgroupitem(transformedDatagroup);
      }

    } catch (error) {

    }
  };
  const fetchUserManagementDetails = async () => {
    try {
      const response = await axios.get(`/api/v1/users/`, {});
      if (response.status === 200) {
        const responseData = response.data.results;
        setUserList(responseData);
      }

    } catch (error) {

    }
  }
  useEffect(() => {
    if (selectedCategoryKey) {
      getgroupsitemsub(selectedCategoryKey);
    }
  }, [selectedCategoryKey]);
  useEffect(() => {
    getaddCountries()
    getcategoriesitem()
    fetchUserManagementDetails();
    fetchUserRoles();
    fetchAllCompanies();
    fetchAllDepartments();
  }, [])

  useEffect(() => {
    if (selectedCountry) {
      getaddStates(selectedCountry.id);
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (selectedState) {
      getaddCities(selectedState.id);
    }
  }, [selectedState]);
  /////////////////////////////////////////////////////naveen pss////////////////////////////

  const [modulepermissions, setmodulepermissions] = useState([]);

  const [roleslist, setroleslist] = useState([]);
  const { register: register1, formState: { errors: errors1 }, handleSubmit: handleSubmit1, getValues: getValues1, setValue: setValue1, trigger: trigger1, reset: reset1, } = useForm({ mode: "onBlur" });
  const [selectedParent, setSelectedParent] = useState([]);
  const [selectedChildren, setSelectedChildren] = useState([]);
  const [actions, setActions] = useState({});
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10 });
  const [smShow, setSmShow] = useState(false)
  const [successAlert, setSuccessAlert] = useState(false);
  const [deleteRowId, setDeleteRowID] = useState(null)
  const [isEdited, setisEdited] = useState(false);
  const [editId, setEditId] = useState(null);
  const [disable, setDisable] = useState(false);

  const handleShowAddUser = () => {
    fetchUserRoles();
    fetchAllCompanies();
    fetchAllDepartments();


  }

  useEffect(() => {
    getAllrolesList();
  }, [lazyParams]);

  const onPageChange = (event) => {
    setLazyParams({ page: event.page, rows: event.rows });
  };

  const getAllrolesList = async () => {
    try {
      const response = await axios.get(`/api/v1/roles/?page=${lazyParams.page + 1}&size=${lazyParams.rows}`, {});
      if (response.data && response.data.results) {

        setroleslist(response.data.results);
        setTotalRecords(response.data.count || 0)
      }
    } catch (error) {
    }
  };

  const getAllSublist = async () => {
    try {
      const response = await axios.get(`/api/v1/get-menu-data/`, {});
      if (response.data && response.data.results) {
        setmodulepermissions(response.data.results);
      }
    } catch (error) {
    }
  };



  const getAllSublistupdate = async (id) => {
    try {
      const response = await axios.get(`/api/v1/roles/${id}/`, {});
      if (response.data) {
        let results = response.data;

        setValue1("roleName", results.role_data.role_name)
        setValue1("createdatesrole", moment(results.role_data.created_at).format("YYYY-MM-DD"))
        let permissions = results.permission_data || [];
        let parentPermissions = new Set();
        let childPermissions = new Set();
        let actionPermissions = {};

        permissions.forEach(permission => {
          let parentIds = permission.parent_id ? permission.parent_id.split(',').map(Number) : [];
          let childIds = permission.child_id ? permission.child_id.split(',').map(Number) : [];

          parentIds.forEach(pid => parentPermissions.add(pid));
          childIds.forEach(cid => childPermissions.add(cid));

          childIds.forEach(cid => {
            actionPermissions[cid] = {
              add: permission.add === cid.toString(),
              edit: permission.edit === cid.toString(),
              delete: permission.delete === cid.toString(),
              view: permission.view === cid.toString(),
            };
          });
        });

        setSelectedParent(Array.from(parentPermissions));
        setSelectedChildren(Array.from(childPermissions));
        setActions(actionPermissions);


      }
    } catch (error) {
    }
  };

  useEffect(() => {
    getAllSublist()
    getAllrolesList()

  }, [])


  const handleParentSelect = (parentId, subMenus) => {
    let updatedSelectedChildren = [...selectedChildren];
    let updatedActions = { ...actions };

    if (selectedParent.includes(parentId)) {
      // If parent is already selected, remove it and all its children
      updatedSelectedChildren = updatedSelectedChildren.filter(
        (id) => !subMenus.map((sub) => sub.menu_id).includes(id)
      );
      setSelectedParent(selectedParent.filter((id) => id !== parentId));
    } else {
      // If parent is selected, add all its children
      updatedSelectedChildren = [
        ...new Set([...updatedSelectedChildren, ...subMenus.map((sub) => sub.menu_id)]),
      ];
      setSelectedParent([...selectedParent, parentId]);
    }

    setSelectedChildren(updatedSelectedChildren);
    setActions(updatedActions);
  };
  // Handle Child Selection
  const handleChildSelect = (childId, parentId) => {
    let updatedSelectedChildren = [...selectedChildren];

    if (selectedChildren.includes(childId)) {
      // If child is selected, remove it
      updatedSelectedChildren = updatedSelectedChildren.filter((id) => id !== childId);
    } else {
      // If child is selected, add it and ensure parent is also selected
      updatedSelectedChildren.push(childId);
      if (!selectedParent.includes(parentId)) {
        setSelectedParent([...selectedParent, parentId]);
      }
    }

    // If no more children are selected, remove the parent
    const parentHasChildren = modulepermissions.find(
      (mod) => mod.menu_id === parentId
    )?.sub_menus?.some((sub) => updatedSelectedChildren.includes(sub.menu_id));

    if (!parentHasChildren) {
      setSelectedParent(selectedParent.filter((id) => id !== parentId));
    }

    setSelectedChildren(updatedSelectedChildren);
  };
  const handleActionSelect = (menuId, actionType) => {
    setActions((prev) => ({
      ...prev,
      [menuId]: {
        ...prev[menuId],
        [actionType]: prev[menuId]?.[actionType] === "10" ? "" : "10",
      },
    }));
  };


  const onSubmit = async (data) => {


    const req = {
      role_name: data.roleName,
      createdatesrole: data.createdatesrole,
      parent_id: selectedParent.join(",") || "",
      child_id: selectedChildren.join(",") || "",
      add: selectedChildren
        .filter((id) => actions[id]?.add === "10")
        .join(",") || "",

      edit: selectedChildren
        .filter((id) => actions[id]?.edit === "10")
        .join(",") || "",

      delete: selectedChildren
        .filter((id) => actions[id]?.delete === "10")
        .join(",") || "",

      view: selectedChildren
        .filter((id) => actions[id]?.view === "10")
        .join(",") || "",
    };

    if (!isEdited) {
      try {
        var rolepost = await axios.post(`/api/v1/roles/`, req,);
        if (rolepost.data) {
          setIsFormVisible(false)
          setaddrolespopup(false)
          getAllrolesList();
        }
        setLoading(false);
        setDisable(false)
      } catch (error) {
        setLoading(false);
        setDisable(false)
      }
    } else {
      try {
        var response = await axios.put(`/api/v1/roles/${editId}/`, req,);
        if (response.data) {
          setaddrolespopup(false)
          getAllrolesList();
        }
        setLoading(false);
        setDisable(false)
      } catch (error) {
        setLoading(false);
        setDisable(false)
      }
    }
  };

  const deleteHandler = async () => {
    let id = deleteRowId
    await axios.delete(`/api/v1/roles/${id}/`)
      .then((resp) => {
        getAllrolesList()
        setSmShow(false)
        setSuccessAlert(true)
      })
      .catch((error) => {
      });
  }
  const [addrolespopup, setaddrolespopup] = useState(false)


  return (
    <React.Fragment>
      <Container fluid={true}>
        <div className="admin-dash">
          <TabView>
            <TabPanel header="User Management" leftIcon="pi pi-lock mr-2">
              <div className="container-fluid mt-3 ps-3">
                <div className="usermanagement-main">
                  {/* <div className="breadcrumb d-flex justify-content-between">
                  <BreadCrumb model={breadUsermanagement} />

                  <button
                    className="p-button p-component mb-3"
                    onClick={() => setSelectedOption(null)}
                  >
                    <i className="pi pi-arrow-left me-2"></i> Back
                  </button>
                </div> */}

                  <TabView className="usermanagement-tab">
                    <TabPanel header="Users">
                      {/* start user management */}

                      <div>
                        <div className="d-flex justify-content-between align-items-center">
                          <h3 className="heading-sz">User</h3>

                          {/* Add User Button */}
                          <div className="mb-3">
                            <Button
                              label="Add User"
                              icon="pi pi-user"
                              className="p-button-primary"
                              onClick={() => { setFormVisible(true); reset(); setdepartment(""); setrolesval(); setSelectedCategoryKey(); setSelectedGroupKey() }}
                            />
                          </div>
                        </div>

                        {/* Form Section (Visible only when formVisible is true) */}
                        {formVisible && (
                          <form className="mb-3 p-3 border rounded" onSubmit={handleSubmit(handleFormSubmit)}>
                            {/* <h4>{isEditMode ? "Edit User" : "Add User"}</h4> */}
                            <div className="field mb-2">
                              <label htmlFor="user_id">Username</label>
                              <InputText id="user_id" className="w-full" placeholder="user_id" {...register("user_id", {
                                required: "Username is required",
                                pattern: onlyAlphabetsandSpaces,
                                minLength: MinLengthValidation(3),
                                maxLength: MaxLengthValidation(100)
                              })} />
                              {errors.user_id && <small className="text-danger">{errors.user_id.message}</small>}
                            </div>

                            <div className="field mb-2">
                              <label htmlFor="password">Password</label>
                              <InputText id="password" className="w-full" type="password" placeholder="Password" {...register("password", {
                                required: "Password is required",
                                pattern: passwordPattern,
                                minLength: MinLengthValidation(6),
                                maxLength: MaxLengthValidation(100)
                              })}
                              />
                              {errors.password && <small className="text-danger">{errors.password.message}</small>}
                            </div>

                            <div className="field mb-2">
                              <label htmlFor="email">Email</label>
                              <InputText id="email" className="w-full" placeholder="Email" {...register("email", {
                                required: "Email is required",
                                pattern: emailValidation
                              })} />
                              {errors.email && <small className="text-danger">{errors.email.message}</small>}
                            </div>

                            <div className="field mb-2">
                              <label htmlFor="role_id">Role</label>
                              <Dropdown
                                value={rolesval}
                                onChange={(e) => setrolesval(e.value)}
                                options={userRoles}
                                optionLabel="name"
                                optionValue="id"
                                filter
                                className="w-full activejobdrop"
                                placeholder="Select Category"
                              />
                              {errors.role_id && <small className="text-danger">{errors.role_id.message}</small>}
                            </div>

                            <div className="field mb-2">
                              <label htmlFor="first_name">First Name</label>
                              <InputText id="first_name" className="w-full" placeholder="Enter first name" {...register("first_name", { required: "First name is required", pattern: { value: /^[A-Za-z][A-Za-z-\s&]+$/, message: "Only alphabets and spaces allowed" } })} />
                              {errors.first_name && <small className="text-danger">{errors.first_name.message}</small>}
                            </div>
                            <div className="field mb-2">
                              <label htmlFor="middle_name">Middle Name</label>
                              <InputText id="middle_name" className="w-full" placeholder="Enter middle name" {...register("middle_name", { required: "Middle name is required", pattern: { value: /^[A-Za-z][A-Za-z-\s&]+$/, message: "Only alphabets and spaces allowed" } })} />
                              {errors.middle_name && <small className="text-danger">{errors.middle_name.message}</small>}
                            </div>
                            <div className="field mb-2">
                              <label htmlFor="last_name">Last Name</label>
                              <InputText id="last_name" className="w-full" placeholder="Enter last name" {...register("last_name", { required: "Last name is required", pattern: { value: /^[A-Za-z][A-Za-z-\s&]+$/, message: "Only alphabets and spaces allowed" } })} />
                              {errors.last_name && <small className="text-danger">{errors.last_name.message}</small>}
                            </div>
                            <div className="field mb-2">
                              <label htmlFor="phone_number">Phone Number</label>
                              <InputText id="phone_number" className="w-full" placeholder="Enter phone number" {...register("phone_number", {
                                required: "Phone Number is required",
                                pattern: onlyNumbers,
                                minLength: MinLengthValidation(10),
                                maxLength: MaxLengthValidation(14)
                              })} />
                              {errors.phone_number && <small className="text-danger">{errors.phone_number.message}</small>}
                            </div>
                            <div className="field mb-2">
                              <label htmlFor="job_title">Job Title</label>
                              <InputText id="job_title" className="w-full" placeholder="Enter job title" {...register("job_title", {
                                required: "Job Title is required",
                                pattern: onlyAlphabetsandSpaces,
                                minLength: MinLengthValidation(3),
                                maxLength: MaxLengthValidation(100)
                              })} />
                              {errors.job_title && <small className="text-danger">{errors.job_title.message}</small>}
                            </div>
                            {/* <div className="field mb-2">
                              <label htmlFor="company">Company</label>
                              <Dropdown
                                id="company"
                                value={selectedCompany} // This binds the selected company id
                                options={companies} // This binds the companies array
                                onChange={(e) => setSelectedCompany(e.value)} // Update the selected company id
                                placeholder="Select Company"
                                optionLabel="name" // Display company name
                                optionValue="id" // Use company id as the value for selection
                                filter // Enable search functionality
                                filterBy="name" // Search by company name
                                className="w-full activejobdrop"
                              />
                              {errors.company && <small className="text-danger">{errors.company.message}</small>}
                            </div> */}
                            <div className="field mb-2">
                              <label htmlFor="department">Department</label>
                              <Dropdown
                                id="company"
                                value={department} // This binds the selected company id
                                options={departmentslist} // This binds the companies array
                                onChange={(e) => setdepartment(e.value)} // Update the selected company id
                                placeholder="Select Company"
                                optionLabel="name" // Display company name
                                optionValue="id" // Use company id as the value for selection
                                filter // Enable search functionality
                                filterBy="name" // Search by company name
                                className="w-full activejobdrop"
                              />
                              {errors.department && <small className="text-danger">{errors.department.message}</small>}
                            </div>
                            <div className="field mb-2">
                              <label htmlFor="category">Category</label>
                              <Dropdown
                                value={selectedCategoryKey}
                                onChange={(e) => setSelectedCategoryKey(e.value)}
                                options={categoriesitem}
                                optionLabel="name"
                                optionValue="id"
                                filter
                                className="w-full activejobdrop"
                                placeholder="Select Category"
                              />
                              {errors.category && <small className="text-danger">{errors.category.message}</small>}
                            </div>
                            <div className="field mb-2">
                              <label htmlFor="group">Groups</label>
                              <Dropdown
                                value={selectedGroupKey}
                                onChange={(e) => setSelectedGroupKey(e.value)}
                                options={groupitem}
                                optionLabel="name"
                                optionValue="id"
                                filter
                                className="w-full"
                                placeholder="Select Group"
                              />
                              {errors.group && <small className="text-danger">{errors.group.message}</small>}
                            </div>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label htmlFor="address">Address</label>
                              </Col>
                              <Col xl={9}>

                                <div className="companie-add" style={{ position: "relative" }}>
                                  <InputTextarea
                                    id="address"
                                    value={address}
                                    // onChange={(e) => setAddress(e.target.value)}
                                    readOnly
                                    placeholder=""
                                    rows={3}
                                    cols={20}
                                    className="w-full"
                                  />

                                  {/* Edit Icon */}
                                  <i
                                    className="pi pi-pencil"
                                    style={{
                                      position: "absolute",
                                      right: "10px",
                                      top: "70%",
                                      transform: "translateY(-50%)",
                                      color: "#6c757d",
                                      cursor: "pointer"
                                    }}
                                    onClick={() => setVisible(true)}
                                  ></i>
                                  <Dialog header="Edit Address" className="address-popup" visible={visible} onHide={() => { if (!visible) return; setVisible(false); }}
                                    style={{ width: '30vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
                                    <div className="card sidebardetails">
                                      <form>

                                        <Row className="mb-3">
                                          <Col lg={6}>
                                            <div className="p-field">
                                              <label htmlFor="street1">Street 1</label>
                                              <InputText
                                                id="street1"
                                                value={street1}
                                                onChange={(e) => { setStreet1(e.target.value); }}
                                                placeholder="Enter Street 1"
                                                className="w-full activejobdrop"
                                              />
                                            </div>
                                          </Col>
                                          <Col lg={6}>
                                            <label htmlFor="street2">Street 2</label>
                                            <InputText
                                              id="street2"
                                              value={street2}
                                              onChange={(e) => { setStreet2(e.target.value); }}
                                              placeholder="Enter Street 2 (Optional)"
                                              className="w-full activejobdrop"
                                            />
                                          </Col>
                                        </Row>



                                        <Row className="mb-3">
                                          {/* <Col lg={6}>
                                            <label htmlFor="country">Country</label>
                                            <Dropdown
                                              id="country"
                                              value={selectedCountry}
                                              onChange={(e) => {
                                                //console.log(e)

                                                setSelectedCountry(e.value)
                                              }}
                                              options={addCountries}
                                              optionLabel="name"
                                              filter
                                              filterPlaceholder="Search Country"
                                              className="w-full activejobdrop"
                                              placeholder="Enter country details..."
                                            />
                                          </Col>


                                          <Col lg={6}>
                                            <label htmlFor="state">State</label>
                                            <Dropdown
                                              id="state"
                                              value={selectedState}
                                              onChange={(e) => { setSelectedState(e.value) }}
                                              options={addStates}
                                              optionLabel="name"
                                              filter
                                              filterPlaceholder="Search State"
                                              className="w-full activejobdrop"
                                              placeholder="Enter state details..."
                                            />
                                          </Col>
                                        </Row>

                                        <Row className="mb-3">
                                          <Col lg={6}>
                                            <label htmlFor="city">City</label>
                                            <Dropdown
                                              id="city"
                                              value={selectedCity}
                                              onChange={(e) => { setSelectedCity(e.value) }}
                                              options={addCities}
                                              optionLabel="name"
                                              filter
                                              filterPlaceholder="Search City"
                                              className="w-full activejobdrop"
                                              placeholder="Enter city details..."
                                            />
                                          </Col> */}
                                          <Col lg={6}>
                                            <label htmlFor="postalCode">Postal Code</label>
                                            <InputText
                                              id="postalCode"
                                              value={postalCode}
                                              onChange={(e) => { setPostalCode(e.target.value) }}
                                              placeholder="Enter Postal Code"
                                              className="w-full activejobdrop"
                                            />
                                          </Col>
                                        </Row>

                                        <Row className="mb-3">
                                          <Col lg={12}>
                                            <label htmlFor="postalCode">Label</label>
                                            <Dropdown
                                              value={selectedLabel1}
                                              onChange={(e) => { setSelectedLabel1(e.value) }}
                                              options={labels}
                                              optionLabel="name"
                                              placeholder="Select a Label"
                                              className="w-full activejobdrop"
                                            />
                                          </Col>
                                        </Row>


                                        <Row>
                                          <Col>
                                            <Button type="button" color="primary" className="btn btn-primary  waves-light me-2 sidebarbtn" onClick={() => {
                                              setAddress([
                                                street1 || "",
                                                street2 || "",
                                                selectedCity?.name || selectedCity || "",  // Extract city name
                                                selectedState?.name || selectedState || "", // Extract state name
                                                selectedCountry?.name || selectedCountry || "", // Extract country name
                                                postalCode || ""
                                              ].filter(Boolean));
                                              setVisible(false);
                                            }}>
                                              <i className="pi pi-check me-1" ></i>  Ok
                                            </Button>
                                            {/* <Button color="primary" className="btn btn-primary  waves-light cancelbtn me-2">
                                                                                                            <i className="pi pi-times me-1"></i>
                                                                                                            Cancel
                                                                                                          </Button> */}
                                          </Col>
                                        </Row>

                                      </form>
                                    </div>
                                  </Dialog>
                                </div>
                              </Col>
                            </Row>

                            <div className="d-flex justify-content-start mt-4">
                              <Button
                                label={isEditMode ? "Update" : "Save"}
                                disabled={isLoading}
                                icon="pi pi-save"
                                className="p-button-primary me-2"
                                type="submit"
                              // onClick={handleFormSubmit}
                              />
                              <Button
                                label="Cancel"
                                icon="pi pi-times"
                                className="p-button-danger"
                                onClick={resetForm} // Cancel action will reset and hide the form
                              />
                            </div>
                          </form>
                        )}

                        {/* DataTable Section */}
                        <DataTable value={userList} responsiveLayout="scroll">
                          <Column field="user_id" header="Username" />
                          <Column field="email" header="Email" />
                          <Column field="role_name" header="Role" />
                          <Column field="is_manager" header="Is Manager" body={(rowData) => {
                            const status = rowData.is_manager; // Assuming 'Status' is the field name in your data
                            let badgeClass = '';
                            // Define the badge style based on the status value
                            switch (status) {
                              case true:
                                badgeClass = 'p-badge-success';
                                break;
                              case false:
                                badgeClass = 'p-badge-danger';
                                break;
                              default:
                                badgeClass = 'p-badge-outline';
                                break;
                            }
                            return (
                              <span className={`p-badge ${badgeClass}`} style={{ borderRadius: '50px', padding: '5px 10px' }}>
                                {status ? 'Yes' : 'No'}
                              </span>
                            );
                          }} />
                          <Column field="date_joined" header="Joined Date" body={(rowData) => rowData.date_joined ? moment(rowData.date_joined).format('DD/MM/YYYY') : ''} />
                          {/* Actions Column for Edit and Delete */}
                          <Column
                            style={{ width: "5%" }}
                            body={(rowData, { rowIndex }) => (
                              <div className="d-flex">
                                <Button
                                  icon="pi pi-pencil"
                                  className="p-button-text p-button-sm me-2"
                                  onClick={() => {
                                    handleEditUser(rowData)
                                    setFormVisible(true)
                                  }}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  className="p-button-text p-button-sm p-button-danger"
                                  onClick={() => handleDeleteUser(rowData?.id)}
                                />
                              </div>
                            )}
                            header="Actions"
                          />
                        </DataTable>
                      </div>

                      {/* end user management */}
                    </TabPanel>

                    <TabPanel header="Roles">
                      {/* Roles start */}

                      <div>
                        <div className="d-flex justify-content-between align-items-center">
                          <h3 className="heading-sz">Roles</h3>

                          {/* Add Role Button */}
                          <div className="mb-3">
                            <Button
                              label="Add Role"
                              icon="pi pi-shield"
                              className="p-button-primary"
                              onClick={() => {
                                // setIsFormVisible(true)
                                setaddrolespopup(true)
                                setisEdited(false)
                                reset1()
                                setSelectedParent([])
                                setSelectedChildren([])
                                setActions("")
                              }}
                            />
                          </div>
                        </div>
                        {isFormVisible && (<>
                          {/* Form Section (Visible only when isFormVisible is true) */}

                        </>)}

                        {/* DataTable Section */}
                        <DataTable value={roleslist}
                          lazy paginator first={lazyParams.page * lazyParams.rows}
                          rows={lazyParams.rows} totalRecords={totalRecords} onPage={onPageChange} loading={loading}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, totalRecords]} // Dynamic row options including "All"
                        >
                          <Column field="role_name" header="Role Name" />
                          <Column field="created_at" header="Create Date" />

                          {/* Actions Column for Edit and Delete */}
                          <Column
                            style={{ width: "5%" }}
                            body={(rowData, { rowIndex }) => (
                              <div className="d-flex">
                                <Button icon="pi pi-pencil" className="p-button-text p-button-sm me-2"
                                  onClick={() => { setaddrolespopup(true); setisEdited(true); setEditId(rowData?.role_id); getAllSublistupdate(rowData.role_id); reset1() }} />
                                <Button icon="pi pi-trash" className="p-button-text p-button-sm p-button-danger"
                                  onClick={() => { setSmShow(true); setDeleteRowID(rowData?.role_id) }} />
                              </div>
                            )}
                            header="Actions"
                          />
                        </DataTable>
                      </div>

                      {/* Roles start */}
                    </TabPanel>


                  </TabView>
                </div>
              </div>
            </TabPanel>

            {/* setting section start */}

            <TabPanel header="Settings" leftIcon="pi pi-cog mr-2">
              <Settingadm />
            </TabPanel>
            <TabPanel header="Lookup Customization" leftIcon="pi pi-search mr-2">
              <Lookup />
            </TabPanel>
          </TabView >
        </div >
      </Container >

      <Dialog
        header="Roles"
        visible={addrolespopup}
        className="interview-popup"
        style={{ width: '50vw' }}
        onHide={() => { if (!addrolespopup) return; setaddrolespopup(false); }}>

        <div>
          <form onSubmit={handleSubmit1(onSubmit)}>
            <div className="mb-3 p-3 border rounded ">
              {/* <h4 className="heading-sz">{isEditModeActive ? "Edit Role" : "Add Role"}</h4> */}
              <div className="roleforms" style={{}}>
                {/* Role Name Field */}
                <div className="row">
                  <div className="col-6">
                    <div className="field mb-2">
                      <label htmlFor="roleNameField">Role Name</label>
                      <InputText
                        className="w-full"
                        {...register1("roleName", {
                          required: "Role Name is required",
                          pattern: {
                            value: /^[a-zA-Z_ ]*$/,
                            message: "Please enter valid Role Name ",
                          },

                        })} onKeyUp={() => { trigger1("roleName") }} />
                      {errors1.roleName && (<small className='form-text text-danger'>{errors1.roleName.message}</small>)}

                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <h5 className="heading-sz mt-3">Module Permissions</h5>
                  {/* Candidates Section */}
                  <div className="row" style={{ minHeight: "200px" }}>
                    {modulepermissions.map((modulerole, index) => (
                      <div className="col-12" key={index} >
                        <div className="mb-3 p-3 border rounded">
                          <Row className="d-flex flex-wrap">
                            <div className="mt-3">
                              <label className="flex items-center space-x-2">
                                <input
                                  type="checkbox"
                                  checked={selectedParent.includes(modulerole.menu_id)}
                                  onChange={() => handleParentSelect(modulerole.menu_id, modulerole.sub_menus)}
                                  value={modulerole.menu_id}
                                />
                                <span className="font-medium ms-2">{modulerole.menu_name}</span>
                              </label>

                              <div className="grid grid-cols-2 gap-4 mt-2">
                                {modulerole.sub_menus?.length > 0 && (
                                  <div className="ml-4 mt-2">
                                    {modulerole.sub_menus.map((submenu, idx) => (
                                      <div key={idx} className="mt-2">
                                        <label className="flex items-center space-x-2">
                                          <input
                                            type="checkbox"
                                            checked={selectedChildren.includes(submenu.menu_id)}
                                            onChange={() => handleChildSelect(submenu.menu_id, modulerole.menu_id)}
                                            value={submenu.menu_id}
                                          />
                                          <span className="font-medium ms-2">{submenu.menu_name}</span>
                                        </label>
                                        {submenu.actions && (
                                          <div className="grid grid-cols-2 gap-4 mt-1 ml-4 pl-4 border-l">
                                            {['add', 'edit', 'delete', 'view'].map(action => (
                                              <label key={action} className="flex items-center space-x-2">
                                                <input
                                                  type="checkbox"
                                                  checked={actions[submenu.menu_id]?.[action] || false}
                                                  onChange={() => handleActionSelect(submenu.menu_id, action)}
                                                />
                                                <span className="ms-2">{action.charAt(0).toUpperCase() + action.slice(1)}</span>
                                              </label>
                                            ))}
                                          </div>
                                        )}

                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          </Row>
                        </div>
                      </div>
                    ))}

                  </div>
                </div>
              </div>

              {/* Action Buttons */}
            </div>
            <div className="d-flex justify-content-end mt-3">
              <Button type="button" label="Cancel" icon="pi pi-times" className="p-button-danger mr-3" onClick={resetFormFields} />
              <Button type='submit' icon="pi pi-save" className="p-button-primary me-2" >Save</Button>
            </div>
          </form>
        </div>

      </Dialog>
      <Modal size="md" show={smShow} onHide={() => setSmShow(false)} className="text-center" >
        <Modal.Header closeButton><h1 className="modal-title fs-5 "> Delete</h1></Modal.Header>
        <div className="text-center m-3 text-danger">  </div>
        <h4 className="text-center m-2"> Are you sure you want to delete this </h4>
        <div className="text-center m-3">
          <Button className="btn btn-primary m-1" onClick={() => setSmShow(false)} >Cancel</Button>
          <button className="btn btn-primary m-1" onClick={deleteHandler}> Delete </button>
        </div>
      </Modal>
      <Modal size="md" show={successAlert} onHide={() => setSuccessAlert(false)} className="text-center" >
        <Modal.Header closeButton><h1 className="modal-title fs-5 "> Success</h1></Modal.Header>
        <div className="text-center m-3"> </div>
        <h4 className="text-center">Delete  Successfully</h4>
        <div className="text-center m-3">
          <button className="btn btn-primary" onClick={() => setSuccessAlert(false)} > OK </button>
        </div>
      </Modal>

    </React.Fragment >

  )
}

export default AdminDashboard
